// extracted by mini-css-extract-plugin
export default {"btnpwd":"f1c76c70fc"};